import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeLanguageProvider } from './context/ThemeLanguageContext';
import LandingPage from './components/LandingPage';
import AdminPage from './components/AdminPage';
import ReportPage from './components/ReportPage';
import ClarityTracker from './components/ClarityTracker';

function App() {
  return (
    <ThemeLanguageProvider>
      <ClarityTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/ads" element={<AdminPage />} />
        <Route path="/report" element={<ReportPage />} />
      </Routes>
    </ThemeLanguageProvider>
  );
}

export default App;

